import { Typography } from "@kyan/ui";
import { useEffect, useState } from "react";

import { formatValue } from "#/utils/valueFormatters";

interface CountdownClockProps {
  seconds: number;
}

export const CountdownClock: React.FC<CountdownClockProps> = ({ seconds }) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [timeLeft]);

  const displayTime = formatValue(timeLeft, {
    template: "0 s",
    minimumIntegerDigits: 2,
  });

  return <Typography primary>{displayTime}</Typography>;
};
